var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('section',{staticClass:"forms"},[(_vm.currentForm === 0)?_c('form-data-empresa',{attrs:{"theme":_vm.style,"form":_vm.dados},on:{"nextSteps":function (data, campo) { return _vm.nextForm(1, campo,  data); }}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }